import useScrollSpy from 'react-use-scrollspy'
import { isEmpty } from '@/helpers/utils'

type ListItem = {
  icon: any
  title: string
  url: string
  slug: string
}

interface Data {
  data: ListItem[] | {}[]
  color?: string
  active?: number
  className?: string
  navRefs: any
}
const font = '#7E868F'

const NavTabs = ({ data, color, active, className, navRefs }: Data) => {
  const theme = color === '#eff5f5' ? '#726EFF' : color

  const activeSection = useScrollSpy({
    sectionElementRefs: navRefs,
    offsetPx: -140,
  })

  return (
    <ul className={`justify-around text-center h-full w-full ${className}`}>
      {data.map(
        (item, index) =>
          !isEmpty(item) && (
            <li
              key={index}
              className={`w-full lg:w-auto h-full ${
                active === index ? 'active' : ''
              }`}
            >
              <a
                className={`flex items-center justify-center text-gray-450 font-medium text-xl pt-1 h-full border-t-4 lg:border-t-0 lg:border-b-4 border-transparent transition-colors hover:border-black `}
                style={{
                  color: activeSection === index ? theme : font,
                  marginBottom: '-1px',
                  borderColor: activeSection === index ? theme : 'transparent',
                }}
                href={(item as ListItem).url}
              >
                <span className='w-6 lg:mr-4'>{(item as ListItem).icon}</span>
                <span
                  className='hidden lg:inline-block'
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: (item as ListItem).title,
                  }}
                />
              </a>
            </li>
          )
      )}
    </ul>
  )
}

export default NavTabs
